import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setSort} from "../redux/slices/filterSlice";

type SortItem = {
    name: string,
    sort: 'rating' | '-rating' | 'price' | '-price' | 'title' | '-title';
}

type PopupClick = MouseEvent & {
    composedPath: () => Node[]
}

export const Sort: React.FC = () => {

    // @ts-ignore
    const sort = useSelector(state => state.filter.sort);
    const dispatch = useDispatch();

    const sortRef = useRef<HTMLDivElement>(null);

    const [open, setOpen] = useState(false);
    const sortList: SortItem[] = [
        {name: 'популярности (DESC)', sort: 'rating'},
        {name: 'популярности (ASC)', sort: '-rating'},
        {name: 'цене (DESC)', sort: 'price'},
        {name: 'цене (ASC)', sort: '-price'},
        {name: 'алфавиту (DESC)', sort: 'title'},
        {name: 'алфавиту (ASC)', sort: '-title'}
    ];

    const onClickSortItem = (obj: SortItem) => {
        dispatch(setSort(obj));
        setOpen(false);
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const _event = event as PopupClick;
            if (sortRef.current && !_event.composedPath().includes(sortRef.current)) {
                setOpen(false);
            }
        }

        document.body.addEventListener('click', handleClickOutside);

        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        }

    }, [])

    return (
        <div ref={sortRef} className={open ? 'sort active' : 'sort'}>
            <div className="sort__label" onClick={() => setOpen(!open)}>
                <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 5C10 5.16927 9.93815 5.31576 9.81445 5.43945C9.69075 5.56315 9.54427 5.625 9.375 5.625H0.625C0.455729 5.625 0.309245 5.56315 0.185547 5.43945C0.061849 5.31576 0 5.16927 0 5C0 4.83073 0.061849 4.68424 0.185547 4.56055L4.56055 0.185547C4.68424 0.061849 4.83073 0 5 0C5.16927 0 5.31576 0.061849 5.43945 0.185547L9.81445 4.56055C9.93815 4.68424 10 4.83073 10 5Z"
                        fill="#2C2C2C"
                    />
                </svg>
                <b>Сортировка по:</b>
                <span>{sort.name}</span>
            </div>
            {
                open && (
                <div className="sort__popup">
                    <ul>
                        {
                            sortList.map((item: any, i) => {
                                return (
                                    <li
                                        key={i}
                                        className={sort.sort === item.sort ? 'active' : ''}
                                        onClick={() => onClickSortItem(item)}
                                    >{item.name}</li>
                                )
                            })
                        }
                    </ul>
                </div>
                )
            }

        </div>
    )
}
